import getOneBundle, { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";
import { bannerInterface } from "../../config/bannerConst";
import { getOnePeopleById } from "../../config/WeChatPeopleConfig";

const {ccclass, property} = cc._decorator;

@ccclass
export default class bannerPrefab extends cc.Component {

    @property({type:cc.Label,displayName:"描述文本"})
    chatLb:cc.Label = null;

    @property({type:cc.Sprite,displayName:"显示图片"})
    headSp:cc.Sprite  = null;

    @property({type:cc.Node,displayName:"bannerBg"})
    bannerBg:cc.Node = null;

    bannerData:bannerInterface = null;

    /**
     * 绑定banner数据
     * @param explain banner描述文本
     * @param people banner展示的npc
     */
    bindData(bannerData:bannerInterface){
        this.bannerData = bannerData;
        this.updateBanner();
    }

    start(){
        this.loadSp();
    }

    /**
     * 更新banner内容
     */
    updateBanner(){
        let people = getOnePeopleById(this.bannerData.peopleId);
        this.chatLb.string = this.bannerData.explain;
        // this.loadSp();
    }

    /**
     * 加载头像
     */
    async loadSp(){
        let people = getOnePeopleById(this.bannerData.peopleId);
        let bundle = await getOneBundle(BUNDLE_SMALL_NAME.WeChatGameBundle,false); 
        let headUrl:string = people.headUrl;
        bundle.load(headUrl,cc.SpriteFrame,(err,asset:cc.SpriteFrame)=>{
            if(err){
                console.error("横幅加载npc头像失败",err);
                return;
            }
            this.headSp.spriteFrame = asset;
        });
    }

    /**
     * banner 显示动画
     */
    async bannerAni(){
        return new Promise<void>(resolve=>{
            this.bannerBg.width = this.chatLb.node.width + 70;
            let targetX:number = -375 - this.bannerBg.width - 100;
            let needTime :number = Math.abs(targetX - 375) / 150;
            cc.tween(this.node).to(needTime,{x:targetX}).start();
            this.scheduleOnce(()=>{
                resolve();
                this.node.destroy();
                this.node.removeFromParent();
            },needTime);
        });
        // await new Promise<void>(resolve=>{
        //     let offsetX:number = this.chatLb.node.width - 650;
        //     let needTime:number = offsetX / 300;
        //     cc.tween(this.chatLb.node).to(needTime,{x:-offsetX}).start();
        //     this.scheduleOnce(resolve,needTime);
        // });

        // return new Promise<void>(resolve=>{
        //     cc.tween(this.node).to(.5,{opacity:0}).start();
        //     this.scheduleOnce(()=>{
        //         resolve();
        //         this.node.destroy();
        //         this.node.removeFromParent();
        //     },.5);
        // });
    }

    
}
